module.exports = __webpack_public_path__ + "static/img/index_video3.bc18a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_video3.jpg
// module id = 2vKn
// module chunks = 1